// Twilio Conversations 3.x (and its twilsock, notifications and mcs-client dependencies) calls crypto.randomUUID(),
// which Safari only added in 15.4 (iOS 15.4, March 2022) and which browsers only expose on secure origins. Without
// it the chat can't connect on older iPhones. crypto.getRandomValues has been available for much longer.
if (typeof window !== 'undefined' && window.crypto && typeof window.crypto.randomUUID !== 'function') {
  (window.crypto as any).randomUUID = () =>
    '10000000-1000-4000-8000-100000000000'.replace(/[018]/g, char => {
      const digit = Number(char);
      return (digit ^ (window.crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (digit / 4)))).toString(16);
    });
}

export {};
